import { ProviderData } from '@/common/types';

const PreSearchMessage = ({
  providers,
  selectedState,
  selectedInsurance,
}: {
  providers: ProviderData[];
  selectedState: string | null;
  selectedInsurance: string | null;
}) => {
  const shouldRender =
    providers.length === 0 &&
    selectedState === null &&
    selectedInsurance === null;

  if (!shouldRender) return null;

  return (
    <div className="text-center text-muted p-4">
      <h5 className="fw-bold mb-2">Find a Provider</h5>
      <p>
        Please select a state and an insurance provider to find a dietitian who
        can help you.
      </p>
    </div>
  );
};

export default PreSearchMessage;
